import { useMutation } from 'react-query';

import { type MutationFunction, useRequest } from '@frontend/api';
import type { BomPart, NodeData, NodeKey } from '@frontend/api';

export type ValidateBomRequestBody = {
  quoteItemId: number;
  partMap: Record<BomPart['uuid'], BomPart>;
  nodeMap: Record<NodeKey, NodeData>;
};

export type ValidateBomResponseBody = null | {
  partMap: Record<BomPart['uuid'], BomPart>;
  nodeMap: Record<NodeKey, NodeData>;
  consolidatedPartsCount: number;
};

export const useValidateBom: MutationFunction<
  ValidateBomResponseBody,
  ValidateBomRequestBody
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(({ quoteItemId, ...body }) => {
    return request(
      `/quotes/items/${quoteItemId}/bom_builder_validate_structure/`,
      {
        query,
        init: {
          method: 'POST',
          body,
        },
      },
    );
  }, queryOptions);
};
